import { FC } from 'react';
import {
  Box,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox
} from '@mui/material';
import findBranchColorById from 'src/utils/findBranchColorById';
import { KumaoTheme } from 'src/theme';

export interface BrancheFacet {
  id: number;
  name: string;
  count: number;
}

interface SearchResultBranchFilterProps {
  branches: BrancheFacet[];
  selectedBrancheIds: number[];
  onChange: (selectedBrancheIds: number[]) => void;
}

const SearchResultBranchFilter: FC<SearchResultBranchFilterProps> = (props) => {
  const { branches, selectedBrancheIds, onChange } = props;

  if (branches.length < 2) {
    return null;
  }

  const handleToggle = (brancheId: number) => {
    if (selectedBrancheIds.includes(brancheId)) {
      onChange(selectedBrancheIds.filter((id) => id !== brancheId));
    } else {
      onChange([...selectedBrancheIds, brancheId]);
    }
  };

  return (
    <Box
      sx={{
        backgroundColor: 'white',
        borderRadius: 5,
        p: 2,
        mb: 2,
        position: { md: 'sticky' },
        top: { md: 16 }
      }}
    >
      <Typography
        variant="subtitle1"
        sx={{ color: (theme: KumaoTheme) => theme.palette.grey[600], mb: 1 }}
      >
        Branchen im Suchergebnis
      </Typography>
      <FormGroup sx={{ flexDirection: 'column' }}>
        {branches.map((branche) => (
          <FormControlLabel
            key={branche.id}
            sx={{ width: '100%' }}
            label={(
              <Typography sx={{ fontSize: 'small' }}>
                {`${branche.name} (${branche.count})`}
              </Typography>
            )}
            control={(
              <Checkbox
                checked={selectedBrancheIds.includes(branche.id)}
                onChange={() => handleToggle(branche.id)}
                sx={{
                  color: findBranchColorById(branche.id),
                  '&.Mui-checked': {
                    color: findBranchColorById(branche.id)
                  }
                }}
              />
            )}
          />
        ))}
      </FormGroup>
    </Box>
  );
};

export default SearchResultBranchFilter;
